
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

function GoldStakeSchemeTab({ tabTitle, tableData, tableHeadData, tabComponent,previewName }) {
    const [value, setValue] = React.useState(0);
    console.log(value, "tabValues")
    const [isPreview, setIsPreview] = React.useState(false); // State to handle preview

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setIsPreview(false); // Reset preview mode when tab is switched
    };

    const handlePreviewClick = () => {
        setIsPreview(true); // Activate preview mode
        setValue(-1); // Set value to -1 to highlight the preview button
    };

    // const tableData = [
    //     { title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" },
    // ];

    // const tableHeadData = ['S.No', 'Title', 'Second Text', 'Sub Text', 'Documents'];

    const renderTabContent = () => {
      
        return tabComponent[value] || null;
    };

    return (
        <div>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'start',
                    py: 1,
                    gap: 2,
                    flexWrap: 'wrap',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        aria-label="scrollable auto tabs example"
                        sx={{
                            '.MuiButtonBase-root-MuiTab-root.Mui-selected ': { color: "#C38F51" },
                        }}
                        TabIndicatorProps={{
                            style: {
                                display: 'none', // Hide the tab indicator
                            },
                        }}
                    >
                        {tabTitle.map((label, index) => (
                            <Tab
                                key={label}
                                label={label}
                                sx={{
                                    fontSize: "14px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    p: "15px 30px", // Reduced padding for the tab
                                    color: value === index ? '#C38F51' : 'black',
                                    textTransform: 'none',
                                    fontWeight: value === index ? 'normal' : 'normal',
                                    height: "20px", // Reduced height for the tab
                                    minWidth: 0, // Ensures no minimum width to reduce space
                                    margin: "0 10px", // Adds spacing between tabs
                                    border: value === index ? '1px solid #C38F51' : '1px solid black',
                                    borderRadius: "23px",
                                    '&.Mui-selected': {
                                        color: 'white',
                                        background: "#C38F51",
                                    },
                                    '&.MuiTab-root': {
                                        minHeight: "0px",
                                    },
                                    '&:hover': {
                                        color: 'white', // Hover effect for unselected tabs
                                    },
                                }}
                            />
                        ))}
                    </Tabs>
                </Box>

                
            </Box>

            <Box>
                {renderTabContent()}
            </Box>
        </div>
    );
}

export default GoldStakeSchemeTab;
